import { useEffect, useState } from 'react';
import './Banner.css';

const carouselImages = ['/fotos/2.png', '/fotos/3.png', '/fotos/4.png', '/fotos/5.png'];

export default function Banner() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (carouselImages.length <= 1) return;

    const timer = window.setInterval(() => {
      setActiveIndex(current => (current + 1) % carouselImages.length);
    }, 5000);

    return () => window.clearInterval(timer);
  }, []);

  return (
    <section className="banner section-shell" aria-label="Banner principal MegaX">
      <div className="banner-content">
        <div className="banner-visual" aria-hidden="true">
          <div className="banner-visual-glow" />
          <div className="banner-carousel">
            <div className="banner-carousel-stage">
              {carouselImages.map((image, index) => (
                <div
                  key={image}
                  className={`banner-carousel-slide${index === activeIndex ? ' is-active' : ''}`}
                  style={{ backgroundImage: `url(${image})` }}
                />
              ))}
            </div>

            <div className="banner-carousel-dots" aria-hidden="true">
              {carouselImages.map(image => (
                <span key={image} className={carouselImages[activeIndex] === image ? 'is-active' : ''} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
